<div class="tool-panel">
    <h3 class="panel-title">Tools</h3>
    <div class="tools-grid">
        @for (tool of tools; track tool.type) {
            <button
                class="tool-button"
                [class.active]="currentTool() === tool.type"
                (click)="selectTool(tool.type)"
                [title]="tool.name + (tool.shortcut ? ' (' + tool.shortcut + ')' : '')">
                <span class="tool-icon">{{ tool.icon }}</span>
                <span class="tool-name">{{ tool.name }}</span>
                @if (tool.shortcut) {
                    <span class="tool-shortcut">{{ tool.shortcut }}</span>
                }
            </button>
        }

        <!-- Shapes Dropdown -->
        <div class="tool-dropdown-wrapper">
            <button
                #shapesButton
                class="tool-button"
                [class.active]="isShapeTool(currentTool())"
                (click)="toggleShapesDropdown()"
                title="Shapes">
                <span class="tool-icon">{{ getActiveShapeIcon() }}</span>
                <span class="tool-name">Shapes</span>
                <span class="dropdown-arrow">▼</span>
            </button>
        </div>
    </div>

    <div class="view-controls">
        <h4>View</h4>
        <label class="checkbox-label">
            <input
                type="checkbox"
                [checked]="gridVisible()"
                (change)="toggleGrid()"/>
            Show Grid
        </label>
        <label class="checkbox-label">
            <input
                type="checkbox"
                [checked]="snapToGrid()"
                (change)="toggleSnapToGrid()"/>
            Snap to Grid
        </label>
        <div class="zoom-controls">
            <button (click)="zoomOut()" title="Zoom Out">−</button>
            <span class="zoom-level">{{ zoomPercent() }}%</span>
            <button (click)="zoomIn()" title="Zoom In">+</button>
            <button (click)="resetZoom()" title="Reset Zoom">⊙</button>
        </div>
    </div>

    <div class="action-controls">
        <h4>Actions</h4>
        <button
            class="action-button add-image-button"
            (click)="addImage()"
            title="Add Image">
            🖼️ Add Image
        </button>
        <button
            class="action-button"
            (click)="canvasService.duplicateSelected()"
            [disabled]="!hasSelection()">
            Duplicate
        </button>
        <button
            class="action-button"
            (click)="canvasService.groupSelected()"
            [disabled]="selectedCount() < 2">
            Group
        </button>
        <button
            class="action-button"
            (click)="canvasService.ungroupSelected()"
            [disabled]="!hasSelection()">
            Ungroup
        </button>
        <button
            class="action-button"
            (click)="deleteSelected()"
            [disabled]="!hasSelection()">
            Delete
        </button>
    </div>

    <div class="history-controls">
        <button
            class="action-button"
            (click)="canvasService.undo()"
            [disabled]="!canUndo()"
            title="Undo (Cmd+Z)">
            ↶ Undo
        </button>
        <button
            class="action-button"
            (click)="canvasService.redo()"
            [disabled]="!canRedo()"
            title="Redo (Cmd+Shift+Z)">
            ↷ Redo
        </button>
    </div>

    <input
        #imageFileInput
        type="file"
        accept="image/*,.svg"
        style="display: none"
        (change)="onImageFileSelected($event)"/>
</div>
